import yup from 'src/infra/Yup';
import {PlatformIntl} from 'src/infra/PlatformIntl';

const intl = PlatformIntl.getInstance();

export type IntegrationField = 'username' | 'password' | 'token';

const ALL_FIELDS: IntegrationField[] = ['username', 'password', 'token'];

/**
 * Cada integração é implementada em código e localiza a própria linha casando o título, então os
 * campos que ela exige moram aqui, junto do formulário. Título fora do mapa é integração cadastrada
 * à mão, sem código que a consuma: mostra os três campos e não exige nenhum.
 */
export const REQUIRED_BY_TITLE: Record<string, IntegrationField[]> = {
  'Asaas': ['token'],
  'Certadoc': ['username', 'password'],
  'CityTag': ['username', 'password'],
  'SSX Cliente': ['username', 'password', 'token'],
  'Herrlog': ['token'],
  'TrackMax': ['username', 'password'],
};

export const fieldsFor = (title?: string) => {
  const required = (title && REQUIRED_BY_TITLE[title]) || [];
  return {required, visible: required.length ? required : ALL_FIELDS};
};

const FIELD_LABELS: Record<IntegrationField, string> = {
  username: intl.formatMessage('sharedUser'),
  password: intl.formatMessage('userPassword'),
  token: 'Token',
};

const SECRETS: IntegrationField[] = ['password', 'token'];

/**
 * O campo que a integração não usa continua indo em branco: a coluna é NOT NULL no banco.
 *
 * Na edição, senha e token não podem ser obrigatórios: o servidor não devolve segredo, então eles
 * chegam vazios no formulário, e vazio significa "mantém o que está guardado". Exigi-los aqui
 * bloquearia trocar só a descrição.
 */
export const integrationConfigSchema = (title?: string, {editing = false} = {}) => {
  const {required} = fieldsFor(title);

  const field = (name: IntegrationField) => {
    const base = yup.string().label(FIELD_LABELS[name]);
    const mustFill = required.includes(name) && !(editing && SECRETS.includes(name));
    return mustFill ? base.required() : base.default('');
  };

  const shape = {
    integrationId: yup.number().label(intl.formatMessage('sharedIntegration')).required(),
    username: field('username'),
    password: field('password'),
    token: field('token'),
    description: yup.string().label(intl.formatMessage('sharedDescription')).required(),
  };

  return editing ?
    yup.object().shape({...shape, id: yup.number().required()}) :
    yup.object().shape(shape);
};
